import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M211.733333,1260.088 C228.053333,1392.03467 280.32,1518.11467 362.986667,1624.888 L362.986667,1624.888 L194.346667,1755.55467 C88.2133333,1618.488 21.0133333,1456.14133 0,1286.22133 L0,1286.22133 Z M1865.888,868.504 C1884.768,926.317333 1898.208,986.264 1905.67467,1046.744 C1910.47467,1086.744 1912.82133,1125.89067 1912.82133,1166.53067 C1912.82133,1207.064 1910.47467,1246.21067 1905.67467,1285.99733 C1884.66133,1456.13067 1817.46133,1618.47733 1711.328,1755.544 L1711.328,1755.544 L1542.688,1624.87733 C1625.35467,1518.104 1677.62133,1392.024 1693.94133,1260.07733 C1697.67467,1229.35733 1699.488,1198.31733 1699.488,1166.53067 C1699.488,1134.63733 1697.67467,1103.59733 1693.94133,1072.664 C1688.07467,1026.05067 1677.83467,979.650667 1663.22133,934.850667 L1663.22133,934.850667 Z M1730.76267,446.797333 L1881.58933,597.624 L1006.176,1473.03733 L486.282667,953.144 L637.109333,802.317333 L1006.176,1171.384 L1730.76267,446.797333 Z M194.346667,577.410667 L362.986667,708.077333 C280.32,814.850667 228.053333,940.930667 211.733333,1072.87733 L211.733333,1072.87733 L0,1046.744 C21.0133333,876.824 88.2133333,714.477333 194.346667,577.410667 L194.346667,577.410667 Z M833.141333,213.709333 L859.274667,425.442667 C727.221333,441.656 601.141333,494.029333 494.474667,576.696 L494.474667,576.696 L363.701333,408.056 C500.768,301.922667 663.008,234.616 833.141333,213.709333 L833.141333,213.709333 Z M1072.59733,213.698667 C1242.624,234.712 1404.97067,301.912 1541.93067,408.045333 L1541.93067,408.045333 L1411.15733,576.685333 C1304.59733,494.018667 1178.41067,441.645333 1046.464,425.432 L1046.464,425.432 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSpeedGraderSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconSpeedGraderSolid, _Component);

  var _super = _createSuper(IconSpeedGraderSolid);

  function IconSpeedGraderSolid() {
    _classCallCheck(this, IconSpeedGraderSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconSpeedGraderSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSpeedGrader",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSpeedGraderSolid.displayName = "IconSpeedGraderSolid";
  return IconSpeedGraderSolid;
}(Component);

IconSpeedGraderSolid.glyphName = 'speed-grader';
IconSpeedGraderSolid.variant = 'Solid';
IconSpeedGraderSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSpeedGraderSolid;
export { IconSpeedGraderSolid };